import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDish = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: .5,
			y1: 16.79,
			x2: 23.5,
			y2: 16.79
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M2.42,16.79H21.58a0,0,0,0,1,0,0V17a3.65,3.65,0,0,1-3.65,3.65H6.07A3.65,3.65,0,0,1,2.42,17v-.18A0,0,0,0,1,2.42,16.79Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M12,7.21h0a9.58,9.58,0,0,1,9.58,9.58v0a0,0,0,0,1,0,0H2.42a0,0,0,0,1,0,0v0A9.58,9.58,0,0,1,12,7.21Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 5.29,
			r: 1.92
		})
	]
});
const ForwardRef = forwardRef(SvgDish);
export default ForwardRef;
